<h2 mat-dialog-draggable-title mat-dialog-title style="margin-bottom: 0px !important;">
  {{'alert.confirm' | translate}}
  <button (click)="onBackClick()" aria-label="Close"
          class="close"
          type="button">
    <span aria-hidden="true">&times;</span>
  </button>
</h2>
<mat-divider></mat-divider>
<div class="row">
  <div class="col-2 pr-0" style="text-align: center;padding-left: 0px !important; padding-top: 15px;">
    <!--<em class="material-icons confirm-ico">
      info
    </em>-->
    <em class="fa fa-warning text-primary large"></em>
  </div>
  <div class="col-10 pl-0">
    <div style=" padding: 5px 7px 15px; font-size: medium; overflow-wrap: break-word;">
      {{ 'messages.confirm_forward_user' | translate }} <b>{{data.receiveName}}</b>
    </div>
  </div>
</div>


<div class="justify-content-center" mat-dialog-actions>

  <!--build icon, set default cancel-->
  <button (click)="onBackClick()" cdkFocusInitial color="primary" mat-stroked-button type="button">
    <mat-icon class="mr-0">cancel</mat-icon>
    {{'button.back' | translate}}
  </button>
  <button (click)="onNextClick()" class="ml-2" color="primary" mat-raised-button>
    <mat-icon class="mr-0">arrow_forward</mat-icon>
    {{'button.accept' | translate}}
  </button>
</div>
